// extracted by mini-css-extract-plugin
module.exports = {"root":"container-module__root___ndyBi"};